import React from 'react'

const DEFAULT_WIDTH = 24
const DEFAULT_HEIGHT = 24

const TickIcon = ({ width = DEFAULT_WIDTH, height = DEFAULT_HEIGHT }: { width?: number; height?: number }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ display: 'block' }}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.90203 17.7851L7.90028 17.7868L9.21318 19.0997L21.75 6.56289L20.4371 5.25L9.21492 16.4722L3.56289 10.8202L2.25 12.1331L7.90203 17.7851Z'
        fill='#141414'
      />
    </svg>
  )
}

export default TickIcon
